const Service=[
    {
        id:1,
        icon:"Images/wire.png",
        Title:"Cable Laying",
        info:"All type of fire fighting system Installation and operator cables"
    },
    {
        id:2,
        icon:"Images/electrical panel.png",
        Title:"All types of Electrical LT/HT Panel",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    },
    {
        id:3,
        icon:"Images/lifts.png",
        Title:"Operation of Lifts",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    },
    {
        id:4,
        icon:"Images/wire.png",
        Title:"Earthing, Lighting Arrested",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
    ,{
        id:5,
        icon:"Images/AC.png",
        Title:"A/C Installation",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
    ,{
        id:6,
        icon:"Images/record.png",
        Title:"Audio/Video Systems",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
    ,{
        id:7,
        icon:"Images/wire.png",
        Title:"Installation of R.O. Unit/Plans",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
    ,{
        id:8,
        icon:"Images/wire.png",
        Title:"Installation of Water Cables",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
    ,{
        id:9,
        icon:"Images/wire.png",
        Title:"LED Board Installation",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
    ,{
        id:10,
        icon:"Images/wire.png",
        Title:"Compound/ Fasad Lightings",
        info:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore"
    }
]
export default Service